import Tooltip from './Tooltip';
import { RunHealthStatus } from '../types/Run';

function getHealthColor(health: number | null | undefined): string {
  switch (health) {
    case RunHealthStatus.GOOD:
      return 'cr-bg-green-500';
    case RunHealthStatus.AVERAGE:
      return 'cr-bg-yellow-500';
    case RunHealthStatus.WARNING:
      return 'cr-bg-orange-500';
    case RunHealthStatus.ERROR:
      return 'cr-bg-red-500';
    default:
      return 'cr-bg-gray-300';
  }
}

function getHealthLabel(health: number | null | undefined): string {
  switch (health) {
    case RunHealthStatus.GOOD:
      return 'Good';
    case RunHealthStatus.NONE:
      return 'None';
    case RunHealthStatus.AVERAGE:
      return 'Average';
    case RunHealthStatus.WARNING:
      return 'Warning';
    case RunHealthStatus.ERROR:
      return 'Error';
    default:
      return 'No data';
  }
}

export default function HealthDot({
  health, reasons,
}: { health: number | null | undefined; reasons?: string[] | null }) {
  const label = getHealthLabel(health);
  const dot = (
    <span className={`cr-inline-block cr-h-3 cr-w-3 cr-rounded-full ${getHealthColor(health)}`} />
  );
  if (!reasons || reasons.length === 0) {
    return <span title={label}>{dot}</span>;
  }
  const body = (
    <div className="cr-text-left">
      <div className="cr-mb-1 cr-font-semibold">{label}</div>
      <ul className="cr-m-0 cr-list-disc cr-pl-4">
        {reasons.map((r, i) => <li key={i}>{r}</li>)}
      </ul>
    </div>
  );
  return <Tooltip title={body} placement="right" multiline>{dot}</Tooltip>;
}
